'use client'

import React, { MouseEventHandler } from 'react'

import Link, { LinkProps } from '@mui/material/Link'

export default function SmoothScrollLink(props: Omit<LinkProps, 'onClick'>) {
  const handleSmoothScroll: MouseEventHandler<HTMLAnchorElement> = e => {
    const target = e.currentTarget.getAttribute('href')

    if (target) {
      const element = document.querySelector(target)
      if (element) {
        e.preventDefault()
        element.scrollIntoView({ behavior: 'smooth' })
        return false
      }
    }
  }

  return <Link {...props} onClick={handleSmoothScroll} />
}
